import { render, staticRenderFns } from "./StocktakingHome.vue?vue&type=template&id=58ac58a3&scoped=true&"
import script from "./StocktakingHome.vue?vue&type=script&lang=js&"
export * from "./StocktakingHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ac58a3",
  null
  
)

export default component.exports